/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tags
 */
export interface Tags {
}

/**
 * Check if a given object implements the Tags interface.
 */
export function instanceOfTags(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TagsFromJSON(json: any): Tags {
    return TagsFromJSONTyped(json, false);
}

export function TagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tags {
    return json;
}

export function TagsToJSON(value?: Tags | null): any {
    return value;
}

